import { ForecastComponentConfig } from 'types'

export function getWorkerComponentConfig(
  config: ForecastComponentConfig = {}
): ForecastComponentConfig {
  // Config entries can carry legacy fields containing measurement instances;
  // only the calculation contract may cross the worker boundary.
  return {
    tmin_by_shell_course: config.tmin_by_shell_course,
    center_plate_radius: config.center_plate_radius,
    cr_by_shell_course: config.cr_by_shell_course,
    api_code_override: config.api_code_override,
    specific_gravity_profile: config.specific_gravity_profile,
    pipe_outer_diameter: config.pipe_outer_diameter,
    pipe_inner_diameter: config.pipe_inner_diameter,
    operation_pressure: config.operation_pressure,
    allowable_unit_stress: config.allowable_unit_stress,
    api_570_weld_type: config.api_570_weld_type,
    binOverrides: config.binOverrides,
  } satisfies {
    [Key in keyof Required<ForecastComponentConfig>]:
      | ForecastComponentConfig[Key]
      | undefined
  }
}
